import React, { useState, useEffect } from 'react';
import { Link, animateScroll as scroll } from 'react-scroll';

const navLinks = [
  { label: 'Services',   target: 'services'   },
  { label: 'Frameworks', target: 'frameworks' },
  { label: 'About',      target: 'about'      },
  { label: 'Contact',    target: 'contact'    },
];

const Navigation = () => {
  const [scrolled, setScrolled] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 20);
    window.addEventListener('scroll', onScroll, { passive: true });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  return (
    <nav className={`sticky top-0 z-50 transition-all duration-300 ${
      scrolled
        ? 'bg-white/92 backdrop-blur-md border-b border-slate-100 shadow-sm'
        : 'bg-white border-b border-slate-100'
    }`}>
      <div className="max-w-7xl mx-auto px-6">
        <div className="flex items-center h-16">

          {/* Logo — emerald → teal gradient */}
          <button
            onClick={() => scroll.scrollToTop({ duration: 600, smooth: true })}
            className="flex items-center gap-3 group"
          >
            <div className="h-8 w-8 rounded-lg bg-gradient-to-br from-em to-teal flex items-center justify-center text-white text-xs font-bold flex-shrink-0 shadow-glow-em group-hover:shadow-glow-em-lg transition-shadow">
              NT
            </div>
            <span className="font-semibold text-slate-800 group-hover:text-slate-900 transition-colors">
              Nova Terra
            </span>
          </button>

          {/* Desktop nav */}
          <ul className="hidden md:flex items-center gap-1 ml-10">
            {navLinks.map((link) => (
              <li key={link.target}>
                <Link
                  to={link.target}
                  smooth={true}
                  duration={500}
                  className="block px-3 py-2 text-sm text-slate-500 hover:text-slate-900 rounded-lg hover:bg-slate-50 cursor-pointer transition-all"
                >
                  {link.label}
                </Link>
              </li>
            ))}
            <li>
              <a href="/ai-assessment" className="block px-3 py-2 text-sm text-slate-500 hover:text-slate-900 rounded-lg hover:bg-slate-50 transition-all">
                AI Assessment
              </a>
            </li>
          </ul>

          <div className="flex items-center gap-3 ml-auto">
            <Link
              to="contact"
              smooth={true}
              duration={500}
              className="hidden md:inline-flex items-center px-5 py-2 rounded-full text-sm font-semibold bg-em text-white hover:bg-em-dark shadow-glow-em hover:shadow-glow-em-lg transition-all cursor-pointer"
            >
              Book a conversation
            </Link>

            <button
              onClick={() => setMobileOpen(!mobileOpen)}
              className="md:hidden p-2 text-slate-500 hover:text-slate-900 transition-colors"
              aria-label="Toggle menu"
            >
              {mobileOpen ? (
                <svg className="w-5 h-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M6 18L18 6M6 6l12 12" />
                </svg>
              ) : (
                <svg className="w-5 h-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M4 6h16M4 12h16M4 18h16" />
                </svg>
              )}
            </button>
          </div>
        </div>

        {mobileOpen && (
          <div className="md:hidden border-t border-slate-100 py-4 space-y-1">
            {navLinks.map((link) => (
              <Link
                key={link.target}
                to={link.target}
                smooth={true}
                duration={500}
                onClick={() => setMobileOpen(false)}
                className="block px-3 py-2.5 text-sm text-slate-600 hover:text-slate-900 rounded-lg hover:bg-slate-50 cursor-pointer"
              >
                {link.label}
              </Link>
            ))}
            <a href="/ai-assessment" className="block px-3 py-2.5 text-sm text-slate-600 hover:text-slate-900 rounded-lg hover:bg-slate-50">
              AI Assessment
            </a>
            <div className="pt-2">
              <Link
                to="contact"
                smooth={true}
                duration={500}
                onClick={() => setMobileOpen(false)}
                className="block w-full text-center px-5 py-2.5 rounded-full text-sm font-semibold bg-em text-white hover:bg-em-dark transition-colors cursor-pointer"
              >
                Book a conversation
              </Link>
            </div>
          </div>
        )}
      </div>
    </nav>
  );
};

export default Navigation;
